import React from 'react';
import { CronParser } from '../components/cron-parser/CronParser';
import '../components/cron-parser/CronParser.css';

export const CronParserPage: React.FC = () => {
  return (
    <div className="page-container">
      <CronParser />
    </div>
  );
};